
const multiplePasswordResetModal = ({ newpassword,onClose }) => {
  return (
    <>
      <div className="modal-overlay">
        <div className="popup">
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
          <div className="tick_mark">
            <h1>✔</h1>
          </div>
          <h2>
            For all students password <br /> reset successfully
          </h2>
          <p>
            One Time Password: <span>{newpassword}</span>
          </p>
          <button className="share-btn" onClick={onClose}>
            Ok
          </button>
        </div>
      </div>
    </>
  );
};

export default multiplePasswordResetModal;
